import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-mr-md" }
const _hoisted_2 = { key: 1 }

import { computed, ref } from "vue";
import { ArtifactProps } from "@/types";
import { useScreen } from "@/hooks";
import { Typography } from "@/components/common";


/**
 * Displays both the body and summary of an artifact.
 * If no summary exists, only the artifact body is displayed.
 */
const __default__ = {
  name: "ArtifactContentDisplay",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artifact: {}
  },
  setup(__props: any) {

const props = __props;

const { smallWindow } = useScreen();

const splitterModel = ref(40);

const showSummary = computed(() => !!props.artifact.summary);
const isCode = computed(() => props.artifact.isCode);

return (_ctx: any,_cache: any) => {
  const _component_q_splitter = _resolveComponent("q-splitter")!

  return (showSummary.value)
    ? (_openBlock(), _createBlock(_component_q_splitter, {
        key: 0,
        modelValue: splitterModel.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((splitterModel).value = $event)),
        horizontal: !isCode.value || _unref(smallWindow)
      }, {
        before: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(Typography), {
              variant: "caption",
              value: "Summary"
            }),
            _createVNode(_unref(Typography), {
              variant: "expandable",
              value: props.artifact.summary,
              "default-expanded": "",
              "collapse-length": 0
            }, null, 8, ["value"])
          ])
        ]),
        after: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(_unref(smallWindow) ? '' : 'q-ml-sm')
          }, [
            _createVNode(_unref(Typography), {
              variant: "caption",
              value: "Content"
            }),
            _createVNode(_unref(Typography), {
              variant: isCode.value ? 'code' : 'expandable',
              value: props.artifact.body,
              "default-expanded": !isCode.value,
              "code-ext": props.artifact.name.split('.').pop(),
              "collapse-length": isCode.value ? undefined : 0
            }, null, 8, ["variant", "value", "default-expanded", "code-ext", "collapse-length"])
          ], 2)
        ]),
        _: 1
      }, 8, ["modelValue", "horizontal"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_unref(Typography), {
          variant: "caption",
          value: "Content"
        }),
        _createVNode(_unref(Typography), {
          variant: isCode.value ? 'code' : 'expandable',
          value: props.artifact.body,
          "default-expanded": !isCode.value,
          "code-ext": props.artifact.name.split('.').pop(),
          "collapse-length": isCode.value ? undefined : 0
        }, null, 8, ["variant", "value", "default-expanded", "code-ext", "collapse-length"])
      ]))
}
}

})